import React from 'react'
import { Link } from 'react-router-dom'
import {getLinkForRepo} from '../../utils/getLinkForRepo'
import {formatRepoGradesToString} from '../../utils/formatRepoGradesToString'
import Icon from '../misc/Icons'
import ProfilePic from '../../components/ProfilePic'
import {Image} from 'cloudinary-react'

class DiscoverRepoLink extends React.Component{

	render(){
		const {repo}=this.props
		
		let gradeString=''
		if(repo.grade){
			gradeString=formatRepoGradesToString(repo.grade)
		}

		return(
			<Link 
				to={getLinkForRepo(repo)}
				className='discover-repoLink'
			>				
				<div className='discover-repoLink-left'>
					<div className='discover-repoLink-left-repoImageContainer'>
						<Image
							key={repo.id}
							cloudName={process.env.REACT_APP_CLOUDINARY_CLOUDNAME}
							publicId={`${repo.image}/repo/${repo.id}`} 
							className='discover-repoLink-left-repoImage'											
							width='450'
							height='450'
							crop='fill'
						/>
					</div>

				</div>
				<div className='discover-repoLink-center'>
					<div className='discover-repoLink-center-title'>
						{repo.name}
					</div>
					<div className='discover-repoLink-center-creator'>
						{/*<ProfilePic size={26} borderRadius={13} user={repo.author} /> */}
						{repo.author.username}
					</div>
					<div className='discover-repoLink-center-grades'>
						{gradeString}
					</div>
					{repo.description &&				
						<div className='discover-repoLink-center-description'>
							{repo.description}				
						</div>
					}
				</div>
				<div className='discover-repoLink-right'>
					<Icon name='chevron-right' />
				</div>
				
			</Link>
		)
	}
}


export default DiscoverRepoLink

